import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { PlusIcon } from '../../../custom_shared/icons';
import { ButtonWithIcon } from '../../../custom_shared/components';
import { useAppStore } from '../../stores';
import { WorksheetModel } from '../../models';
import './AddBalanceInformationButton.less';

interface Props {
    worksheet: WorksheetModel;
}

const AddBalanceInformationButton: React.FC<Props> = ({ worksheet }) => {
    const { actionStore } = useAppStore();

    return (
        <div className="add-balance-information-button-container">
            <ButtonWithIcon
                label="Add balance information..."
                icon={<PlusIcon />}
                onClick={() => actionStore.addBalanceInformation(worksheet.id)}
                disabled={worksheet.isLocked}
            />
        </div>
    );
};

export default observer(AddBalanceInformationButton);
